import { useEffect, useState } from 'react';
import axios from 'axios';

// Same GET /api/document-milestones endpoint useDocumentMilestones.js
// already calls, but kept as the raw, chronological row list instead of
// collapsed into a { milestone: occurred_at } map — a repeatable milestone
// (Ship, Hold/Release, Cancel Backorder) can occur more than once, each
// with its own comment, and the map shape only ever keeps the last one.
// Feeds Sales Order's Status History (SalesOrderTimeline.js).
function useDocumentMilestoneLog(documentType, documentId) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!documentType || !documentId) return;
    axios.get('/api/document-milestones', { params: { document_type: documentType, document_id: documentId } })
      .then((res) => {
        // An undated row (reached before its moment was recorded) sorts as
        // if it happened at the document's first recorded moment. Sorting is
        // stable and the server sends undated rows last, so they land just
        // after creation and before anything recorded later.
        const data = res.data.data || [];
        const dated = data.filter((r) => r.occurred_at).map((r) => new Date(r.occurred_at).getTime());
        const earliest = dated.length ? Math.min(...dated) : 0;
        const at = (r) => (r.occurred_at ? new Date(r.occurred_at).getTime() : earliest);
        setRows([...data].sort((a, b) => at(a) - at(b)));
      })
      .catch(() => setRows([]));
  }, [documentType, documentId]);
  return rows;
}

export default useDocumentMilestoneLog;
